<div class="d-flex">
  <app-tabs-form [activeForm]="activeForm" [account_type]="account_type" [draft]="draft"
    (changeForm)="changeForm($event)" [role]="role" [updatesTabs]="updatesTabs"
    [document_buttons_chico]="document_buttons_chico" [showBrokerExcludeTab]="showBrokerExcludeTab"></app-tabs-form>

  <div class="card w-100 form-right">

    <div class="back">
      <h2 *ngIf="!draft">{{ "forms.names.addstock" | translate }}</h2>
      <div *ngIf="draft" class="div-title">

        <h2>
          {{ title }}

        </h2>
      </div>
      <i class="icon-cross2" (click)="emitBackButtonClick()"></i>
    </div>


    <div class="card-body">
      <div class="row">
        <div class="form">
          <form [formGroup]="form">
            <div [hidden]="activeForm !== 'general'">
                <app-general-form [stockData]="stockData" [ladata]="ladata" [hasExcludedBrokers]="hasExcludedBrokers"
                  (brokerSelected)="onBrokerSelected($event)">
                </app-general-form>
            </div>

            <div [hidden]="activeForm !== 'vehicle'">
              <app-vehicle-form [stockData]="stockData" [stockPreData]="stockPreData" [ladata]="ladata"></app-vehicle-form>
            </div>

           
            <div [hidden]="activeForm !== 'bastidores'">
              <app-bastidores-tab [stockData]="stockData" [ladata]="ladata"></app-bastidores-tab>
            </div>

            <div [hidden]="activeForm !== 'timeline'">
            <app-timeline [stock_reference]="stock_reference"></app-timeline>
            </div>

          
          </form>
        </div>
      </div>

      <div class="div-form"></div>

      <div class="btn-send d-flex align-items-center justify-content-end w-100 ml-4">

          <button *ngIf="!draft" type="submit" class="btn btn-primary btn-primary-form" (click)="onSubmit()">
            <span>
              {{ "buttons.createdraft" | translate }}
            </span>
          </button>
          <button *ngIf="draft && !isDocumentForm()" type="submit" class="btn btn-primary btn-primary-form"
            (click)="onSubmitDraft()">
            <span>
              {{ "buttons.update_stock" | translate }}
            </span>
          </button>

      </div>
    </div>
  </div>
</div>
